module.exports = __webpack_public_path__ + "img/send-otp.0651488d.svg";